import { render, staticRenderFns } from "./EventOutcomeMultiSelect.vue?vue&type=template&id=668c7b36"
import script from "./EventOutcomeMultiSelect.vue?vue&type=script&lang=ts"
export * from "./EventOutcomeMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports